(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/chat/assets/javascripts/use-chat-handler.js') >= 0) return;  svs.modules.push('/components/marketplace/chat/assets/javascripts/use-chat-handler.js');

'use strict';

const {
  useCallback,
  useEffect,
  useRef
} = React;
const {
  useDispatch,
  useSelector
} = ReactRedux;
const {
  formfactor
} = svs.core.detect;
const {
  chatData
} = svs.components.chat;
const {
  useFocusTrap
} = svs.components.lbUtils;
const isDesktop = formfactor.desktop();
const useChatHandler = _ref => {
  let {
    groupId
  } = _ref;
  const dispatch = useDispatch();
  const chat = useSelector(state => state.Chat);
  const {
    releaseFocus,
    trapFocus
  } = useFocusTrap({
    refocus: true
  });
  const ref = useRef(null);
  const handleChat = useCallback(e => {
    if (isDesktop) {
      document.querySelector('.chat-container').focus();
      return false;
    }
    const roomId = "marketplace_".concat(groupId);
    ref.current = e.currentTarget;
    dispatch(chatData.actions.toggleChat(roomId));
  }, [groupId, dispatch]);
  useEffect(() => {
    const chatWrapper = document.querySelector('.chat-container');
    const keyHandler = e => {
      if (e.key === 'Escape' && chat.isOpen) {
        const roomId = "marketplace_".concat(groupId);
        dispatch(chatData.actions.toggleChat(roomId));
      }
    };
    if (chat.isOpen) {
      trapFocus(chatWrapper);
      document.addEventListener('keydown', keyHandler);
    } else {
      releaseFocus();
    }
    return () => {
      document.removeEventListener('keydown', keyHandler);
    };
  }, [chat.isOpen, trapFocus, releaseFocus, dispatch, groupId]);
  const aria = {
    'aria-expanded': isDesktop ? undefined : "".concat(chat.isOpen)
  };
  return {
    aria,
    handleChat,
    label: isDesktop ? 'Hoppa direkt till chatten' : 'Visa chatten'
  };
};
setGlobal('svs.components.marketplace.chat.useChatHandler', useChatHandler);

 })(window);